import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import LinkButton from 'flarum/common/components/LinkButton';
export default function () {
  const entry = () => m(LinkButton, {
    icon: app.forum.attribute('moneyLeaderBoardIcon') || 'fas fa-sort-amount-up',
    href: app.route('moneyLeaderboard')
  }, app.translator.trans('ziven-money-leaderboard.forum.leaderboard-name'));
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    if (app.forum.attribute('allowViewLeaderbaord') && Number(app.forum.attribute('moneyLeaderBoardEntryPosition')) === 0) items.add('MoneyLeaderboard', entry(), 15);
  });
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (app.forum.attribute('allowViewLeaderbaord') && Number(app.forum.attribute('moneyLeaderBoardEntryPosition')) === 1) items.add('MoneyLeaderboard', entry(), 15);
  });
}